var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Model, Prop } from 'vue-property-decorator';
import { Student } from '@/models/Student';
import ErrorHandler from '@/support/ErrorHandler';
import { DateTime } from 'luxon';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { UserFile } from '@/models/UserFile';
import { RolesEnum } from '@/items/Roles';
import AQuillEditor from '@/components/AQuillEditor/AQuillEditor.vue';
let Notes = class Notes extends Vue {
    constructor() {
        super(...arguments);
        this.activeTab = '/notes';
        this.content = '';
        this.noteName = '';
        this.isCreatingPDF = false;
        this.isSavingAndUploading = false;
        this.isUploadingToDrive = false;
    }
    get dialogOptions() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.save', 0, { item: this.$tc('dialogOptions.item.note') }),
            type: 'success',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                },
            },
        };
    }
    mounted() {
        this.fetchStudent();
    }
    fetchStudent() {
        if (!this.student) {
            return;
        }
        new Student()
            .include('note')
            .find(this.student.id)
            .then((student) => {
            const note = student.note;
            if (note == null) {
                this.content = '';
                return;
            }
            if (typeof note === 'string') {
                this.content = note;
                return;
            }
            this.content = note.text || '';
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    saveAndUpload() {
        this.isSavingAndUploading = true;
        this.save();
        this.exportQuill();
    }
    save() {
        try {
            this.student.update({ note: this.content });
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    exportQuill() {
        this.isUploadingToDrive = false;
        const html2pdf = this.getHtml2Pdf();
        if (!html2pdf) {
            return;
        }
        const element = document.getElementsByClassName('ql-editor')[0];
        if (!element) {
            return;
        }
        this.isCreatingPDF = true;
        const header = document.createElement('h1');
        header.innerText = `${this.$t('subject.tab.notes')} - ${this.student.name || ''} - ${DateTime.local().toFormat('yyyy-LL-dd')}`;
        element.prepend(header);
        element.removeAttribute('data-placeholder');
        const filename = this.noteName;
        const html2pdfOptions = {
            margin: 0,
            filename,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: window.devicePixelRatio, imageTimeout: 0, useCORS: true },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
        };
        // New Promise-based usage:
        if (this.isSavingAndUploading) {
            html2pdf()
                .set(html2pdfOptions)
                .from(element)
                .output('blob')
                .then((val) => {
                this.blobToFile(val, filename);
                header.remove();
                this.isCreatingPDF = false;
                this.$store.dispatch('openDialog', this.dialogOptions);
            });
            return;
        }
        html2pdf()
            .set(html2pdfOptions)
            .from(element)
            .save()
            .then(() => {
            header.remove();
            this.isCreatingPDF = false;
            this.$store.dispatch('openDialog', this.dialogOptions);
        });
    }
    blobToFile(blob, fileName) {
        const tempBlob = blob;
        tempBlob.lastModifiedDate = new Date();
        tempBlob.name = fileName;
        const notesFile = blob;
        this.uploadFileToScoolDrive(notesFile, fileName);
    }
    closeDialog() {
        this.$emit('closed');
    }
    uploadFileToScoolDrive(notesFile, fileName) {
        new UserFile()
            .user(this.student)
            .createWithACL(notesFile, fileName, [RolesEnum.TEACHER, RolesEnum.ADMIN, RolesEnum.ROOT])
            .then((response) => {
            if (response) {
                this.isSavingAndUploading = false;
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    getHtml2Pdf() {
        if (typeof window === 'undefined') {
            return null;
        }
        const html2pdfModule = require('html2pdf.js');
        return html2pdfModule && html2pdfModule.default
            ? html2pdfModule.default
            : html2pdfModule;
    }
};
__decorate([
    Model('student', { default: () => new Student() }),
    __metadata("design:type", typeof (_a = typeof Student !== "undefined" && Student) === "function" ? _a : Object)
], Notes.prototype, "student", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], Notes.prototype, "dialog", void 0);
Notes = __decorate([
    Component({
        components: {
            AQuillEditor,
            'loader-card': LoaderCard,
        },
    })
], Notes);
export default Notes;
